import { combineReducers } from 'redux';
import myPrivilegesReducer from './myPrivilegesReducer';
import checkCoverageReducer from './checkCoverageReducer';

export default combineReducers({
  myPrivileges: myPrivilegesReducer,
  womanProduct: checkCoverageReducer,
});
